import { render, staticRenderFns } from "./DesgloseISR.vue?vue&type=template&id=3eb49d9d&scoped=true"
import script from "./DesgloseISR.vue?vue&type=script&lang=js"
export * from "./DesgloseISR.vue?vue&type=script&lang=js"
import style0 from "./DesgloseISR.vue?vue&type=style&index=0&id=3eb49d9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb49d9d",
  null
  
)

export default component.exports